/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleVersionState } from './moduleVersionState';

export type ModuleStateTransitionFromState = ModuleVersionState | null;
